import { Stack, Modal, Typography, Box } from "@mui/material";
import CustomDialogFooter from "../../../shared/components/CustomDialogFooter";

const style = {
  position: "absolute",
  top: "55%",
  left: "50%",
  transform: "translate(-50%, -100%)",
  width: 500,
  bgcolor: "white",
  boxShadow: 24,
  p: "20px",
  borderRadius: "16px",
  outline: "none",
  backgroundColor: "background.paper",
};

export function DeleteRoleFromUserModal(props) {
  const {
    open,
    handleClose,
    onConfirm,
    deleteCategory,
    userName,
    display_name,
  } = props;
  return (
    <Modal open={open} onClose={handleClose}>
      <Box sx={style}>
        <Stack gap="16px">
          <Stack direction="row" alignItems="center" gap="12px">
            <img src="/icons/ic_pair_dialog.svg" alt="warning icon" />
            <Typography fontWeight={500} variant="body1" fontSize={20}>
              Remove Role?
            </Typography>
          </Stack>

          <Typography fontStyle={400} fontSize="16px">
            Would you like to remove role{" "}
            <Box component="span" fontWeight="500">
              “{display_name}”
            </Box>
            from the user
            <Box component="span" fontWeight="500">
              “{userName}”
            </Box>
            ?
          </Typography>
        </Stack>

        <CustomDialogFooter
          disabled={deleteCategory?.isPending}
          onSubmit={onConfirm}
          handleClose={handleClose}
          submitButton="Delete"
          submitButtonColor="error"
          sx={{ p: 0 }}
        />
      </Box>
    </Modal>
  );
}
